import mustache from "mustache";
import { IPage } from "../../shared/components/definitions/page/IPage";
import { ClimaEvapotranspiracionHumedadChartRender } from "../../shared/components/modulos/clima/ClimaEvapotranspiracionHumedadChartRender";
import { ClimaForecastListaRender } from "../../shared/components/modulos/clima/ClimaForecastListaRender";
import { ClimaHeaderRender } from "../../shared/components/modulos/clima/ClimaHeaderRender";
import { ClimaTemperaturaPrecipitacionChartRender } from "../../shared/components/modulos/clima/ClimaTemperaturaPrecipitacionChartRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import { APP_RUTA_FINCA } from "../components/ClienteAsideMenuRender";
import template from "./climaForecastTemplate.html";

mustache.parse(template);

/** Página de pronóstico de clima (próximos días) de la finca activa. En
 *  construcción: se arma sección por sección (separadas con <hr class="sx-divider">). */
export class ClimaForecastPage implements IPage {
  private _header: ClimaHeaderRender | null = null;
  private _lista: ClimaForecastListaRender | null = null;
  private _chart: ClimaTemperaturaPrecipitacionChartRender | null = null;
  private _evapotranspiracion: ClimaEvapotranspiracionHumedadChartRender | null =
    null;

  render(pageContent: HTMLDivElement): void {
    this._header = new ClimaHeaderRender(
      () => serviceProvider.getLayoutService().navigate(APP_RUTA_FINCA),
      "diario",
    );
    this._lista = new ClimaForecastListaRender();
    this._chart = new ClimaTemperaturaPrecipitacionChartRender("rango");
    this._evapotranspiracion = new ClimaEvapotranspiracionHumedadChartRender(
      "rango",
    );

    pageContent.innerHTML = mustache.render(template, {
      header: this._header.render(),
      lista: this._lista.render(),
      chart: this._chart.render(),
      evapotranspiracion: this._evapotranspiracion.render(),
    });

    this._header.connect();
    this._lista.connect();
    this._chart.connect();
    this._evapotranspiracion.connect();
  }

  dispose(): void {
    this._header?.dispose();
    this._lista?.dispose();
    this._chart?.dispose();
    this._evapotranspiracion?.dispose();
  }
}
